module.exports = __webpack_public_path__ + "img/APSicon5.444b877b.png";